import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import ChargeWaiverRegistrationContMain from "presentation/view/container/ChargeWaiverRegistration/ChargeWaiverRegistrationContMain";

CommonEntrypoint(<ChargeWaiverRegistrationContMain />)